import { render } from "./DayColumn.vue?vue&type=template&id=0530db34"
import script from "./DayColumn.vue?vue&type=script&lang=js"
export * from "./DayColumn.vue?vue&type=script&lang=js"
script.render = render

export default script